var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.934,15.934V0h-31.868v15.934H16.992v39.834h23.901v249.612c0,24.943,20.221,45.164,45.164,45.164h339.886 c24.944,0,45.164-20.221,45.164-45.164V55.768h23.901V15.934H271.934z M425.943,318.677H86.057 c-7.329,0-13.296-5.967-13.296-13.296V55.768h366.478v249.612C439.239,312.71,433.272,318.677,425.943,318.677z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "240.066,366.478 174.448,509.883 206.316,509.883 240.066,436.127 240.066,509.883 271.934,509.883  271.934,436.796 305.7,511.307 337.552,512 271.934,366.478  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.554,145.256c-11.95-14.416-30.047-23.667-50.221-23.667c-0.856,0-1.844,0-2.926,0.07 c-0.015,0-0.023,0-0.046,0c-0.024,0-0.031,0-0.07,0v0.008c-34.498,1.618-62.008,30.07-62.016,64.981 c0.008,35.921,29.144,65.058,65.058,65.066c35.921-0.008,65.058-29.144,65.066-65.066c0.008-15.724-5.609-30.14-14.821-41.368 L231.554,145.256z M220.397,150.586l-38.76,34.762v-51.909C196.933,133.516,210.688,140.138,220.397,150.586z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.573,
    y: 125.572,
    className: "st0",
    width: 95.603,
    height: 23.901
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.573,
    y: 173.374,
    className: "st0",
    width: 95.603,
    height: 23.901
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.573,
    y: 221.175,
    className: "st0",
    width: 63.735,
    height: 23.901
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboard);
export default __webpack_public_path__ + "static/media/whiteboard.5883c2d30224810025a97ab6ed768e6b.svg";
export { ForwardRef as ReactComponent };